<script>
	import next from 'array-next'
	import prev from 'array-previous'
	import { scale } from 'svelte/transition'

	export let testimonials = []
	export let arrowImage = '/wp-content/uploads/2020/07/slider-arrow.png'

	let activeTestimonial = testimonials[0]

	let height = 0
	let transition

	$: if (height && !transition) {
		setTimeout(() => {
			transition = true
		}, 0)
	}

	$: nextTestimonial = next(testimonials, activeTestimonial)
	$: prevTestimonial = prev(testimonials, activeTestimonial)
	$: activeTestimonialLogo = activeTestimonial.logo
</script>

<style>
	.transition {
		transition: padding 0.5s;
	}
</style>

<h2>What Clients Say</h2>

<div
	class="testimonial-carousel"
	class:transition
	style="padding-bottom:{height}px">
	<div bind:clientHeight={height}>
		<div class="tc-logo-row">
			<button on:click={() => (activeTestimonial = prevTestimonial)}>
				<img src={arrowImage} alt="" />
				<span>{prevTestimonial.name}</span>
			</button>
			<div class="tc-logo">
				{#each [activeTestimonialLogo] as logo (logo)}
					<div
						style="background-image:url({logo})"
						in:scale={{ start: 1.1, duration: 500, delay: 50 }}
						out:scale={{ start: 0.9, duration: 500 }} />
				{/each}
			</div>
			<button on:click={() => (activeTestimonial = nextTestimonial)}>
				<span>{nextTestimonial.name}</span>
				<img src={arrowImage} alt="" />
			</button>
		</div>
		<div class="tc-contents">
			{#each [activeTestimonial] as testimonial (testimonial)}
				<div
					class="tc-content"
					in:scale={{ start: 1.05, duration: 500, delay: 50 }}
					out:scale={{ start: 0.9, duration: 500 }}>
					{@html testimonial.content}
					{#if testimonial.author}
						<span class="squiggle" />
						<small>
							{@html testimonial.author}
						</small>
					{/if}
				</div>
			{/each}
		</div>
	</div>
</div>
